import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    employees: any[];

    filter: {
        employeeId: any;
        deliveryZoneGroupId: any;
        targetDate: Date;
    };

    planItems: any[];
    factItems: any;
    texts: any;
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    employees: [],

    filter: {
        employeeId: null,
        deliveryZoneGroupId: null,
        targetDate: new Date(),
    },


    planItems: [],
    factItems: {},
    texts: {},
};

export const EMPLOYEE_LIST = 'EMPLOYEE_LIST';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {

    loadData({ commit, getters, dispatch, state }, params) {
        const vm = (this as any)._vm;
        commit('START_LOADING')

        if(params && params.employeeId) {
            state.filter.employeeId = params.employeeId;
        }
        if(params && params.deliveryZoneGroupId) {
            state.filter.deliveryZoneGroupId = params.deliveryZoneGroupId;
        }
        let dates: any[] = [];
        
        // @ts-ignore
        if (state.filter.targetDate instanceof Array) {
            const currDate = moment(state.filter.targetDate[0]);
            const lastDate = moment(state.filter.targetDate[1]);
            console.log('dates 0', currDate, lastDate);
            while (currDate.isSameOrBefore(lastDate)) {
                dates.push(currDate.format('YYYY-MM-DD'));
                currDate.add(1, 'days');
            }
        } else {
            dates = [moment(state.filter.targetDate || new Date()).startOf('day').format('YYYY-MM-DD')]
        }
        console.log('dates', state.filter.targetDate, dates);

        vm.$db([
            ...dates.map((date: any, idx: any) => vm.$q('PLAN_FACT-' + idx)
                .raw('planfact')
                .action({
                    'employee_id': state.filter.employeeId,
                    'delivery_zone_group_id': state.filter.deliveryZoneGroupId ? state.filter.deliveryZoneGroupId : undefined,
                    'date': date
                })),
            vm.$q('WA_TEXT')
                .raw('documents.list')
                .action({
                    "columns": {
                        id: 'wt.id',
                        client_id: 'wt.client_id',
                        text: 'wt.text',
                    },
                    "from": "s:wa_texts",
                    "from_as": "wt",
                }),
            ...dates.map((date: any, idx: any) => vm.$q('WHATSAPP_SEND_LOG-' + idx)
                .raw('documents.list')
                .action({
                    "columns": {
                        id: 'wsl.id',
                        client_id: 'wsl.client_id',
                        delivery_point_id: 'wsl.delivery_point_id',
                        employee_id: 'wsl.employee_id',
                        employee_name: 'employee.name',
                        send_date: 'wsl.send_date',
                    },
                    "from": "s:whatsapp_send_log",
                    "from_as": "wsl",
                    page_size: 100000000,
                    joins: [
                        {
                            join: 's:employees',
                            type: 'left',
                            as:   'employee',
                            on: {
                              $eq: ['wsl.employee_id', 'employee.id']
                            }
                        },
                    ],
                    "where": {
                        "$and": [
                            // {$eq: [`wsl.employee_id`, {$: state.filter.employeeId}]},
                            {$eq: [`wsl.send_date`, {$: date}]}
                        ] 
                    }
                })
            )
        ]).then(((result: ServerResult) => {
            const pf = result.getOperationNames().reduce((acc: any, name: string) => {
                if (name.includes('PLAN_FACT')) {
                    const res = result.getOperation(name).getContent();
                    acc.plan = [...acc.plan, ...res.plan];
                    acc.fact = [...acc.fact, ...res.fact];
                }
                return acc
            }, {fact: [], plan: []});
            const text = result.getOperation('WA_TEXT').getContent();
            const wsl = result.getOperationNames().reduce((acc: any, name: string) => {
                if (name.includes('WHATSAPP_SEND_LOG')) {
                    result.getOperation(name).getContent().documents.map((item: any) => {
                        acc[item.delivery_point_id] = item  
                    })
                }
                return acc
            }, {});



            state.planItems = pf.plan.map((item: any) => {
                item.send_log = wsl[item.source_attributes.delivery_point_id]
                return {
                    ...item,
                    edit: false
                }
            })
            const fact: any[] = pf.fact.map((item: any) => {
                item.dow = moment(item.expected_date).isoWeekday()
                return item
            })

            state.factItems = {
                today: fact.filter((item: any) => item.dow !== 1 || item.expected_date == state.filter.targetDate),
                monday: fact.filter((item: any) => item.dow == 1 )
            }
            state.texts = text.documents.reduce((prev: any, item: any) => {
                prev[item.client_id || '0'] = item;
                return prev;
            }, {})
            commit('LOADED_SUCCESS')
        }));
    },

    changeFilterValue({commit, dispatch}, {field, newValue}) {
        console.log('{field, newValue}', {field, newValue})
        commit('CHANGE_VALUE', {field, newValue});

        dispatch('loadData');
    },

    markItemForEdit({state}, index) {
        state.planItems[index].edit = true
    },

    changeItemValue({state}, { index, field, newValue}) {
        state.planItems[index][field] = newValue
    },

    saveItem({state, rootState}, item) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('SAVE').create('todo_solutions', {
                    todo_id: item.source_id,
                    author_id: (rootState as any).ubic.actor.document.id,
                    body: item.reply
                })
            ]).then((result: ServerResult) => {
                resolve();
            });
        })
    },

    rejectDeal({ commit, getters, dispatch, state }, params) {
        const vm = (this as any)._vm;

        vm.$db([
            vm.$q('SAVE')
            .create('client_deals_schedule_rejections', params)
        ]).then(((result: ServerResult) => {
            dispatch('loadData');
        }));
    },

    saveWASendLog({ rootState, dispatch, state }, item) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('SAVE').create('s:whatsapp_send_log', {
                    client_id: item.source_related_to_id,
                    delivery_point_id: item.source_attributes.delivery_point_id,
                    employee_id: (rootState as any).ubic.actor.document.id,
                    send_date: moment(state.filter.targetDate || new Date()).startOf('day').format('YYYY-MM-DD')
                })
            ]).then(((result: ServerResult) => {
                resolve(null);
            }));
        });
    },

};

export const mutations: MutationTree<WorkPlanBoardState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },
    SET_EMPLOYEE_LIST(state, data) {
        state.employees = data.documents;
    },
    CHANGE_VALUE(state: WorkPlanBoardState, {field, newValue}) {
        (state.filter as any)[field] = newValue;
    },
};

const getters: GetterTree<WorkPlanBoardState, RootState> = {

};

export const STORE_KEY = '$_work_plan_board';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
